import { gql } from '@apollo/client';

export const UPDATE_CUSTOMER_INFO_GQL = gql`
    mutation UpdateCustomerV2($firstname: String, $lastname: String, $date_of_birth: String, $is_subscribed: Boolean) {
        updateCustomerV2(
            input: {
                firstname: $firstname
                lastname: $lastname
                date_of_birth: $date_of_birth
                is_subscribed: $is_subscribed
            }
        ) {
            customer {
                firstname
                lastname
                date_of_birth
                is_subscribed
            }
        }
    }
`;

export const CHANGE_PASSWORD_GQL = gql`
    mutation ChangeCustomerPassword($currentPassword: String!, $newPassword: String!) {
        changeCustomerPassword(currentPassword: $currentPassword, newPassword: $newPassword) {
            email
        }
    }
`;

export const GET_LIST_ADDRESS_GQL = gql`
    query getListAddress {
        customer {
            addresses {
                id
                customer_id
                default_billing
                default_shipping
                firstname
                lastname
                street
                company
                city
                region {
                    region_code
                    region
                    region_id
                }
                postcode
                country_code
                telephone
            }
        }
    }
`;
export const UPDATE_CUSTOMER_ADDRESS_SQL = gql`
    mutation updateCustomerAddress(
        $id: Int!
        $countryCode: CountryCodeEnum
        $firstname: String!
        $lastname: String!
        $company: String!
        $street: [String]!
        $city: String!
        $regionId: Int
        $postcode: String!
        $phonenumber: String
        $default_shipping: Boolean
    ) {
        updateCustomerAddress(
            id: $id
            input: {
                region: { region_id: $regionId }
                country_code: $countryCode
                street: $street
                telephone: $phonenumber
                postcode: $postcode
                city: $city
                company: $company
                firstname: $firstname
                lastname: $lastname
                default_shipping: $default_shipping
            }
        ) {
            id
            firstname
            lastname
            region {
                region
                region_code
                region_id
            }
            country_code
            street
            telephone
            postcode
            city
            company
            default_shipping
            default_billing
        }
    }
`;

export const DELETE_CUSTOMER_ADDRESS_SQL = gql`
    mutation deleteCustomerAddress($id: Int!) {
        deleteCustomerAddress(id: $id)
    }
`;

export const SET_DEFAULT_CUSTOMER_ADDRESS_SQL = gql`
    mutation updateCustomerAddress($id: Int!, $default_shipping: Boolean) {
        updateCustomerAddress(id: $id, input: { default_shipping: $default_shipping }) {
            id
            firstname
            lastname
            region {
                region
                region_code
                region_id
            }
            country_code
            street
            telephone
            postcode
            city
            company
            default_shipping
            default_billing
        }
    }
`;
export const CREATE_CUSTOMER_ADDRESS_SQL = gql`
    mutation createCustomerAddress(
        $countryCode: CountryCodeEnum
        $firstname: String!
        $lastname: String!
        $company: String!
        $street: [String]!
        $city: String!
        $regionId: Int
        $postcode: String!
        $phonenumber: String
        $default_shipping: Boolean
    ) {
        createCustomerAddress(
            input: {
                region: { region_id: $regionId }
                country_code: $countryCode
                street: $street
                telephone: $phonenumber
                postcode: $postcode
                city: $city
                company: $company
                firstname: $firstname
                lastname: $lastname
                default_shipping: $default_shipping
            }
        ) {
            id
            firstname
            lastname
            region {
                region
                region_code
                region_id
            }
            country_code
            street
            telephone
            postcode
            city
            company
            default_shipping
            default_billing
        }
    }
`;

export const GET_CUSTOMER_ORDER_LIST_GQL = gql`
    query getOrder($currentPage: Int!, $pageSize: Int!) {
        customer {
            orders(pageSize: $pageSize, currentPage: $currentPage) {
                total_count
                page_info {
                    page_size
                    current_page
                }
                items {
                    number
                    order_date
                    status
                    total {
                        grand_total {
                            value
                            currency
                        }
                    }
                }
            }
        }
    }
`;

export const GET_CUSTOMER_ORDER_DETAIL_GQL = gql`
    query orders($param: String!) {
        customer {
            orders(filter: { number: { eq: $param } }) {
                items {
                    number
                    order_date
                    status
                    items {
                        status
                        product_name
                        product_sku
                        product_url_key
                        product_sale_price {
                            value
                        }
                        product_sale_price {
                            value
                            currency
                        }
                        quantity_ordered
                        quantity_invoiced
                        quantity_shipped
                    }
                    shipping_method
                    payment_methods {
                        name
                        type
                    }
                    shipping_address {
                        firstname
                        lastname
                        region
                        country_code
                        street
                        city
                        telephone
                        postcode
                    }
                    billing_address {
                        firstname
                        lastname
                        region
                        country_code
                        street
                        city
                        telephone
                        postcode
                    }
                    shipments {
                        id
                        number
                        items {
                            product_name
                            quantity_shipped
                        }
                    }
                    total {
                        grand_total {
                            value
                            currency
                        }
                        total_tax {
                            value
                        }
                        subtotal {
                            value
                            currency
                        }
                        taxes {
                            amount {
                                value
                                currency
                            }
                            title
                            rate
                        }
                        shipping_handling {
                            total_amount {
                                value
                            }
                        }
                        discounts {
                            amount {
                                value
                                currency
                            }
                            label
                        }
                    }
                }
            }
        }
    }
`;

export const QUERY_GET_PRODUCT_ORDER = gql`
    query products($url_key: [String!]!, $pageSize: Int = 20) {
        products(filter: { url_key: { in: $url_key } }, pageSize: $pageSize) {
            items {
                id
                sku
                thumbnail {
                    url
                    label
                }
                url_key
                ... on ConfigurableProduct {
                    variants {
                        product {
                            id
                            name
                            sku
                        }
                        attributes {
                            uid
                            label
                            code
                            value_index
                        }
                    }
                }
            }
        }
    }
`;
